// extracted by mini-css-extract-plugin
module.exports = {"add-question-button":"styles_add-question-button__K3WgD"};